
import {defineComponent} from "vue";
import {arrayHasContent} from "@/helpers/functions/arrays";
import CbLibraryOverviewItem from "@/components/layouts/content-pages/wysiwyg/libraries/CbLibraryOverviewItem.vue";
import {ContentBlockLibraryRestService} from "@/services/rest/cms-content-block/ContentBlockLibraryRestService";

export default defineComponent({
  name: "CbLibraryOverview",
  components: {CbLibraryOverviewItem},
  emits: ["exceptions", "select"],
  props: {
    cbType: {
      type: String,
      required: true,
    },
    libraryCode: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isReady: false as boolean,
    libContentBlocks: [] as any[],
  }),
  mounted() {
    this.reloadContent();
  },
  computed: {
    hasContentBlocks(): boolean {
      return arrayHasContent(this.libContentBlocks);
    },
  },
  methods: {
    async reloadContent(): Promise<void> {
      this.isReady = false;

      try {
        this.libContentBlocks = await ContentBlockLibraryRestService.getInstance()
          .findLibraryContentBlocks(this.libraryCode);
      } catch (exceptions: any) {
        this.$emit('exceptions', exceptions);
      }

      this.isReady = true;
    },
  },
});
